// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuestionModal-Form .Field {
  margin-bottom: 1rem;
}
.QuestionModal-Form .Field .Field-Label {
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--bs-primary);
  display: block;
}

.QuestionModal-Footer {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  padding: 1rem 0;
}
.QuestionModal-Footer .btn {
  flex-grow: 1;
  max-width: 10rem;
}`, "",{"version":3,"sources":["webpack://./src/features/Settings/pages/Questions/components/QuestionModal/styles.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAEI;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAAN;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AAFF;AAIE;EACE,YAAA;EACA,gBAAA;AAFJ","sourcesContent":[".QuestionModal-Form {\n  .Field {\n    margin-bottom: 1rem;\n\n    .Field-Label {\n      text-transform: uppercase;\n      font-size: 0.8rem;\n      font-weight: 600;\n      color: var(--bs-primary);\n      display: block;\n    }\n  }\n}\n\n.QuestionModal-Footer {\n  display: flex;\n  justify-content: center;\n  gap: 1.5rem;\n  padding: 1rem 0;\n\n  .btn {\n    flex-grow: 1;\n    max-width: 10rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
